import { runInAction } from 'mobx'
import { type IResponseEventMessage } from 'entities/Message'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { Message } from 'entities/Message/model/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ILocalTypeInbox } from 'entities/Inbox'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import { useEventMessageUpdatedNewGlobal } from 'entities/Conversation/events/EventMessageUpdatedNewGlobal'
import {
  canAddConversationToList,
  type ConversationListStore,
} from 'pages/conversations/ui/ConversationList'

export const useEventMessageUpdatedNew = (
  conversationListStore: ConversationListStore,
  view: ILocalTypeInbox
) => {
  const entities = useEntitiesContext()
  const { conversationStore } = entities
  const handler = (data: IResponseEventMessage) => {
    const item = new Conversation(data.conversation, entities)
    const message = new Message(
      {
        message: data.message,
      },
      entities
    )
    const { conversationSearchStore, filtersStore } = conversationListStore
    const update = () => {
      const conversation = data.conversation
      conversation.recent_message = data.message

      conversationStore.updateItem(conversation)
      conversationStore.getItem(conversation.id)?.handleChecked(item.checked)
      conversationListStore.updateItemOrder(item.id)
    }

    runInAction(() => {
      // Smart view
      if (view === 'smart_view') {
        const smartView = entities.inboxesStore.localInboxes.currentSmartView

        if (!smartView) return
        if (!checkFilterSmartView(item.smartViewFilterParams, smartView.filters)) return
        if (!filtersStore.isShowConversation(item, message)) return

        update()

        return
      }

      // Default
      if (conversationSearchStore.isActive) return
      if (!filtersStore.isShowConversation(item, message)) return
      if (canAddConversationToList(data.conversation, entities)) {
        update()
      }
    })
  }

  useEventMessageUpdatedNewGlobal(handler, [view])
}
